// utils/schemaUtils.ts

export const generateWebPageSchema = (title: any, url: string) => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: title ?? "Collegehai",
  url: url,
});
export const generateFAQSchema = (faqData: any) => {
  if (!faqData?.questions?.length) return null;

  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqData.questions.map((q: any) => ({
      "@type": "Question",
      name: q.Question,
      acceptedAnswer: {
        "@type": "Answer",
        text: q.Answer,
      },
    })),
  };
};

export const generateBreadcrumbSchema = (
  collegeData: any,
  isAbroadCollege: boolean,
  domain_url: string | undefined,
  college_url: string
) => {
  if (!collegeData?.city?.city_name || !collegeData?.city?.city_url) return [];

  return [
    {
      "@type": "ListItem",
      position: 1,
      name: "Collegehai Home",
      item: isAbroadCollege ? `${domain_url}/study-abroad` : `${domain_url}/`,
    },
    {
      "@type": "ListItem",
      position: 2,
      name: `${collegeData.city.city_name} Colleges`,
      item: `${domain_url}/colleges-in-${collegeData.city.city_url}`,
    },
    {
      "@type": "ListItem",
      position: 3,
      name: collegeData.abbreviation ?? collegeData.college_name,
      item: college_url,
    },
  ];
};

export const generateAggregateRatingSchema = (
  title: string,
  url: string,
  rating = 4.5,
  reviews = "900"
) => ({
  "@context": "https://schema.org",
  "@type": "CollegeOrUniversity",
  name: title,
  url: url,
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: rating,
    reviewCount: reviews,
    bestRating: 5,
    worstRating: 1,
  },
});

export const generateArticleSchema = (
  title: string,
  domain_url: string | undefined,
  url: string,
  author_name: string,
  updatedAt?: Date,
  publishedAt?: Date,
  image?: any
) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  mainEntityOfPage: {
    "@type": "WebPage",
    "@id": url,
  },
  headline: title,
  dateModified: updatedAt || "2024-09-13T16:35:28+05:30",
  datePublished: publishedAt || "2014-05-14T18:47:55+05:30",
  author: {
    "@type": "Person",
    name: author_name || "Collegehai Team",
  },
  publisher: {
    "@type": "Organization",
    name: "Collegehai",
    logo: {
      "@type": "ImageObject",
      name: "Collegehai",
      url: `${domain_url}/images/logo.png`,
      height: "160",
      width: "60",
    },
  },
  image: {
    "@type": "ImageObject",
    url: image || `${domain_url}/images/logo.png`,
    height: "800",
    width: "800",
  },
});
